import {css} from '@emotion/react'
import useControlledState from '@/hooks/useControlledState.mjs'
import {CollapseButton} from './CollapseButton.jsx'
import {CollapseContent} from './CollapseContent.jsx'

const cssCollapse = css({
    display: 'grid',
    position: 'relative',
})

const cssCollapseExpanded = css({
    overflow: 'hidden',
    border: '0 solid #e8e8e8',
})

const cssCollapsePosition = {
    top: css({borderTopWidth: 1}),
    right: css({borderRightWidth: 1}),
    bottom: css({borderBottomWidth: 1}),
    left: css({borderLeftWidth: 1}),
}

export const Collapse = ({
    children,
    defaultIsExpanded,
    isExpanded,
    position,
    onChange,
    ...props
}) => {
    const [_isExpanded, setIsExpanded] = useControlledState(
        void 0 === position || defaultIsExpanded,
        isExpanded,
        onChange,
    )

    const csss = [cssCollapse]

    if (_isExpanded) {
        csss.push(cssCollapseExpanded, cssCollapsePosition[position])
    }

    const onClick = () => setIsExpanded(b => !b)

    return (
        <div
            css={csss}
            {...props}
        >
            <CollapseContent isExpanded={_isExpanded}>
                {children}
            </CollapseContent>

            <CollapseButton
                position={position}
                isExpanded={_isExpanded}
                onClick={onClick}
            />
        </div>
    )
}
